import { Directive, OnDestroy, OnInit, Self } from '@angular/core';
import { AutoUnsubscribe, KalInputComponent } from '@kalidea/kaligraphi';
import { Subscription } from 'rxjs';

@Directive({
    // eslint-disable-next-line
    selector: 'kal-input[type=password]',
    standalone: false
})
export class PasswordInputDirective implements OnInit, OnDestroy {

  displayInClearText = false;

  @AutoUnsubscribe()
  private subcription = Subscription.EMPTY;

  constructor(@Self() private kalInput: KalInputComponent) {
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.kalInput.icon = ' visibility ';
    this.subcription.unsubscribe();
    this.subcription = this.kalInput.iconClicked.subscribe(() => {
      this.displayInClearText = !this.displayInClearText;
      this.kalInput.type = this.displayInClearText ? 'text' : 'password';
    });
  }

}
